export enum ErrorPages {
  E500 = 500,
  E400 = 400,
  E404 = 404,
}
